import type { PricingPageCopy } from '~/data/pricing-page-copy';
import loaders from '#build/page-data/pricing-loaders.mjs';

// Kept apart from usePricingPageCopy.ts so plugins/home-i18n.ts, which runs on every
// page, doesn't pull the English pricing copy into the entry chunk; only the pricing
// components that render it import that. English is already in their JS module, so
// only a non-English override is serialized.
export const usePricingPageCopyState = () => useState<{ code: string; copy: PricingPageCopy } | null>(
  'pricing-page-copy', () => null,
);

export const loadPricingPageCopy = async (code: string) =>
  await (loaders[code] ?? loaders.en)() as PricingPageCopy;
